import React from "react";
import styled, { useTheme } from "styled-components";
import { Box } from "../../Box";
import { Flex } from "../../Flex";
import { Text } from "../../Text";
import { Icon } from "../../Icon";
import { Tooltip } from "../../Tooltip";
import { Caret } from "./Caret";
const BorderedBox = styled(Box) `
  border-bottom: ${({ isSorted, theme: { colors: { tableColors }, }, }) => (isSorted ? `3px solid ${tableColors.tableSortedIndicator}` : `3px solid ${tableColors.tableBorder}`)};
  padding: 8px;

  &:first-child {
    padding: 8px 8px 8px 18px; /* support legacy margins */
  }

  &:last-child {
    padding: 8px 18px 8px 8px; /* support legacy margins */
  }
`;
export const HeaderCell = (props) => {
    const { column, getHeaderProps } = props;
    const { align, isSorted, sortedIndex, isSortedDesc, nowrap, width } = column;
    const { colors: { tableColors }, } = useTheme();
    const sortCaret = React.createElement(Caret, { ml: 2, color: tableColors.tableRowHeaderCaret, direction: isSortedDesc ? "down" : "up" });
    return (React.createElement(BorderedBox, Object.assign({ as: "th", minWidth: width, fontWeight: "normal", isSorted: isSorted && sortedIndex === 0 }, column.getHeaderProps(column.getSortByToggleProps()), (getHeaderProps && column.getHeaderProps(getHeaderProps(column))), props),
        React.createElement(Flex, { flexDirection: "row", justifyContent: "space-between", alignItems: "center", whiteSpace: nowrap ? "nowrap" : "normal" },
            React.createElement(Text, { flex: 1, display: "flex", flexDirection: "row", textAlign: align !== null && align !== void 0 ? align : "left" },
                column.render("Header"),
                column.Tooltip && (React.createElement(Tooltip, { content: column.render("Tooltip") },
                    React.createElement(Box, { pt: "2px", ml: 1 },
                        React.createElement(Icon, { src: "QuestionMark", size: "12px" }))))),
            React.createElement(Box, { width: 3 }, isSorted && sortedIndex === 0 && sortCaret))));
};
